import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeeGroups,
  getResellersSimple,
  reset
} from "redux/admin/crypto-payout-fee-groups/cryptoPayoutFeeGroupsSlice";
import CryptoPayoutFeeGroups from "components/Panel/Admin/CryptoPayoutFeeGroups";
import { toast } from "react-toastify";

const CryptoPayoutFeeGroupsContainer = () => {
  const dispatch = useDispatch();
  const {
    feeGroups,
    resellers,
    isCreateSuccess,
    isUpdateSuccess,
    isDeleteSuccess,
    isError,
    isCreateError,
    isUpdateError,
    isDeleteError,
    isResellersError,
    message
  } = useSelector((state) => state.adminCryptoPayoutFeeGroups);

  // Fetch data on mount
  useEffect(() => {
    dispatch(getFeeGroups());
    dispatch(getResellersSimple());
  }, [dispatch]);

  // Handle success/error states
  useEffect(() => {
    if (isCreateSuccess) {
      toast.success("Grup başarıyla oluşturuldu!");
      dispatch(reset());
      dispatch(getFeeGroups());
    }
    if (isUpdateSuccess) {
      toast.success("Grup başarıyla güncellendi!");
      dispatch(reset());
      dispatch(getFeeGroups());
    }
    if (isDeleteSuccess) {
      toast.success("Grup başarıyla silindi!");
      dispatch(reset());
      dispatch(getFeeGroups());
    }

    // Error handling
    if (isError) {
      toast.error(message || "Gruplar yüklenirken hata oluştu!");
      dispatch(reset());
    }
    if (isCreateError) {
      toast.error(message || "Grup oluşturulurken hata oluştu!");
      dispatch(reset());
    }
    if (isUpdateError) {
      toast.error(message || "Grup güncellenirken hata oluştu!");
      dispatch(reset());
    }
    if (isDeleteError) {
      toast.error(message || "Grup silinirken hata oluştu!");
      dispatch(reset());
    }
    if (isResellersError) {
      toast.error(message || "Bayiler yüklenirken hata oluştu!");
      dispatch(reset());
    }
  }, [
    dispatch,
    isCreateSuccess,
    isUpdateSuccess,
    isDeleteSuccess,
    isError,
    isCreateError,
    isUpdateError,
    isDeleteError,
    isResellersError,
    message
  ]);

  return (
    <div className="bg-black min-h-screen p-4">
      <h2 className="text-2xl font-semibold text-white-100 mb-4">
        Kripto Ödeme Komisyon Grupları
      </h2>

      <CryptoPayoutFeeGroups data={feeGroups} resellers={resellers} />
    </div>
  );
};

export default CryptoPayoutFeeGroupsContainer;